// import React, { useState } from 'react';
// import { Row, Table } from 'react-bootstrap';
// import { t } from 'i18next';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import ImageViewModal from '../../../components/elements/ImageViewModal';

// export function DownloadSection(props) {
//   const [showModal, setShowModal] = useState(false);
//   const closeModal = () => {
//     setShowModal(false);
//   };
//   const handleDownload = () => {
//     const link = document.createElement('a');
//     link.href = `data:image/png;base64,${props?.formData?.doc}`;
//     link.download = props?.formData?.fileName || 'download.png'; // Default file name if none provided
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };
//   return (
//     <Row>
//       <div className="relative overflow-x-auto ">
//         <Table className="mt-3" controlId="volunteerAPTable">
//           <thead className="    bg-customgreen uppercase ">
//             <tr className="">
//               <th className="w-2 font-bold text-white text-sm">{t('sNo')}</th>
//               <th className="font-bold text-white text-sm ">{t('File Name')}</th>
//               <th className="w-1/5 font-bold text-white text-sm">{t('Action')}</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr className="text-sm">
//               <td>1</td>
//               <td>
//                 {
//                   <a href={`data:image/png;base64,${props.formData?.doc}`} download={props.formData?.fileName}>
//                     {props.formData?.fileName}
//                   </a>
//                 }
//               </td>
//               <td>
//                 <div className="flex gap-2 ">
//                   <button
//                     type="button"
//                     className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
//                     onClick={handleDownload}
//                   >
//                     <FileDownloadOutlinedIcon />
//                   </button>

//                   <button
//                     className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
//                     type="button"
//                     onClick={() => setShowModal(true)}
//                   >
//                     <VisibilityOutlinedIcon />
//                   </button>
//                   <ImageViewModal
//                     showModal={showModal}
//                     setShowModal={setShowModal}
//                     closeModal={closeModal}
//                     title={''}
//                     renderLink={''}
//                     imgDoc={props.formData?.doc}
//                   />
//                 </div>
//               </td>
//             </tr>
//           </tbody>
//         </Table>
//       </div>
//     </Row>
//   );
// }
import React, { useState } from "react";
import { Row, Table } from "react-bootstrap";
import { t } from "i18next";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ImageViewModal from "../../../components/elements/ImageViewModal";

export function DownloadSection({ formData }) {
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const handleDownload = () => {
    if (formData?.doc) {
      const link = document.createElement("a");
      link.href = `data:image/png;base64,${formData.doc}`;
      link.download = formData.fileName || "download.png"; // Default file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const isDataAvailable = !!formData?.doc; // Data check

  return (
    <Row>
      <div className="relative overflow-x-auto">
        <Table className="mt-3" controlId="volunteerAPTable">
          <thead className="bg-customgreen uppercase">
            <tr>
              <th className="w-2 font-bold text-white text-sm">{t("sNo")}</th>
              <th className="font-bold text-white text-sm">{t("File Name")}</th>
              <th className="w-1/5 font-bold text-white text-sm">{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-sm">
              <td>1</td>
              <td>
                {isDataAvailable ? (
                  <a
                    href={`data:image/png;base64,${formData.doc}`}
                    download={formData.fileName}
                  >
                    {formData.fileName}
                  </a>
                ) : (
                  <span className="text-gray-400">{t("No file available")}</span>
                )}
              </td>
              <td>
                <div className="flex gap-2">
          
                  <button
                    type="button"
                    className={`w-20 text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center ${
                      isDataAvailable ? "" : "opacity-50 cursor-not-allowed"
                    }`}
                    onClick={isDataAvailable ? handleDownload : undefined}
                    disabled={!isDataAvailable}
                  >
                    <FileDownloadOutlinedIcon />
                  </button>

           
                  <button
                    className={`w-20 text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center ${
                      isDataAvailable ? "" : "opacity-50 cursor-not-allowed"
                    }`}
                    type="button"
                    onClick={isDataAvailable ? () => setShowModal(true) : undefined}
                    disabled={!isDataAvailable}
                  >
                    <VisibilityOutlinedIcon />
                  </button>

             
                  <ImageViewModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    closeModal={closeModal}
                    title=""
                    renderLink=""
                    imgDoc={formData?.doc}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Row>
  );
}
